import { useEffect, useState, useRef } from "react";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import { stateCodeArray } from "../../services/fakeDB/ListUser";
import $ from "jquery";

function getDigits(s = "") {
  return String(s || "").replace(/\D/g, "");
}
function isValidZIP(s) {
  return getDigits(s).length === 5;
}
function isPartialZIP(s) {
  const len = getDigits(s).length;
  return len > 0 && len < 5; // 1..4 digits => partial/invalid
}
function formatPhoneNumber(value) {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`;
}

const EditCustomer = ({ userDetails, userUpdate }) => {
  const { userRole, userToken, userSession, SetSharedObject } = useUserStore((state) => ({
    userRole: state.userRole,
    userToken: state.userToken,
    userSession: state.userSession,
    SetSharedObject: state.SetSharedObject,
  }));
  const [answers, setAnswers] = useState(null);
  const [name, setName] = useState(null);
  const setAnswer = (questionId, answer) => {
    setAnswers((prev) => ({ ...(prev || {}), [questionId]: answer }));
  };
  const [processing, SetProcessing] = useState(false);
  const [frmSubmFlag, SetFrmSubmFlag] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");
  const closeButtonRef = useRef(null);
  const triggerRef = useRef(null); 

  const ClearFields = async () => {
    let o = {};
    if (userDetails?.billingAddressId) {
      var date = new Date("Tue Jul 12 2011 16:00:00 GMT-0700");
      var dateStrToSendToServer = date.toISOString();
      o = {
        Id: userDetails.billingAddressId,
        AlternatePhone: userDetails.billingAddress.alternatePhone,
        City: userDetails.billingAddress.city,
        Country: userDetails.billingAddress.country,
        Fax: formatPhoneNumber(
          userDetails.billingAddress.fax?.substring(0, 10)
        ),
        FaxExt: userDetails.billingAddress.fax?.substring(
          10,
          userDetails.billingAddress.fax.length
        ),
        Phone: formatPhoneNumber(
          userDetails.billingAddress.phone?.substring(0, 10)
        ),
        PhoneExt: userDetails.billingAddress.phone?.substring(
          10,
          userDetails.billingAddress.phone.length
        ),
        State: userDetails.billingAddress.state,
        Street1: userDetails.billingAddress.street1,
        Street2: userDetails.billingAddress.Street2,
        ZIP: userDetails.billingAddress.zip,
        IsCertAddress: false,
        CreatedBy: userSession?.preferred_username?.split("|")[0] ?? userRole,
        ModifiedBy: userSession?.preferred_username?.split("|")[0] ?? userRole,
        DateModified: dateStrToSendToServer,
        SystemCreated: dateStrToSendToServer,
        SystemModified: userSession?.preferred_username?.split("|")[0] ?? userRole,
      };
    }
    setAnswers(o);
  };
  useEffect(() => {
    setName(userDetails);
    ClearFields();
    return () => { ClearFields(); };
  }, [userDetails]);

  const updateUser = async () => {
    SetFrmSubmFlag(true);
    //SetProcessing(true);
    const zipDigits = getDigits(answers?.ZIP || "");
    if (!answers?.ZIP || zipDigits.length === 0) {
      document.getElementById("ZIP").scrollIntoView();
      document.getElementById("ZIP").focus();
      return;
    }
    if (zipDigits.length > 0 && zipDigits.length < 5) {
      // 1..4 digits -> invalid
      document.getElementById("ZIP").scrollIntoView();
      document.getElementById("ZIP").focus();
      return;
    }
    if (!isValidZIP(answers?.ZIP)) {
      // any other invalid case (safety)
      document.getElementById("ZIP").scrollIntoView();
      document.getElementById("ZIP").focus();
      return;
    }

    if (!answers.Street1) {
      document.getElementById("Street1").scrollIntoView();
      document.getElementById("Street1").focus();
      return;
    } else if (!answers.City) {
      document.getElementById("City").scrollIntoView();
      document.getElementById("City").focus();
      return;
    } else if (!answers.State) {
      document.getElementById("State").scrollIntoView();
      document.getElementById("State").focus();
      return;
    } else if (!answers.Phone) {
      document.getElementById("Phone").scrollIntoView();
      document.getElementById("Phone").focus();
      return;
    }

    var phone = answers.Phone?.replace(/[^0-9]/g, "").substring(0, 10);
    var fax = answers.Fax?.replace(/[^0-9]/g, "").substring(0, 10);
    if (phone.length < 10) {
      document.getElementById("Phone").scrollIntoView();
      document.getElementById("Phone").focus();
      return;
    }
    if (fax.length > 0 && fax.length < 10) {
      document.getElementById("Fax").scrollIntoView();
      document.getElementById("Fax").focus();
      return;
    }

    SetFrmSubmFlag(false);
    answers.Phone = phone + answers.PhoneExt;
    answers.Fax = fax + answers.FaxExt;
    let call = "/customers/UpdateCustomerAddress";
    const res = await CallAPI(call, answers, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let obj = {
        alternatePhone: answers.AlternatePhone,
        city: answers.City,
        country: answers.Country,
        county: answers.County,
        fax: answers.Fax,
        id: answers.Id,
        phone: answers.Phone,
        state: answers.State,
        street1: answers.Street1,
        street2: answers.Street2,
        zip: answers.ZIP,
      };
      userUpdate({ ...userDetails, billingAddress: obj });
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
      CloseModal();
    }
  };

  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  const CloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }

      $('#editCustomerModal').modal('hide');
      triggerRef.current?.focus();
    };

  return (
    <div className="EditCustomer">
      <div
        className="modal fade"
        id="editCustomerModal"
        data-backdrop="false"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="editCustomerModalTitle"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <h2
                className="modal-title spacer-inline text-size3"
                id="editCustomerModalTitle"
              >
                Edit Details
              </h2>
              <button
                type="button"
                className="close"
                ref={closeButtonRef}
                onClick={(e) => {
                  CloseModal();
                  ClearFields();
                }}
                aria-label="Close Edit Details dialog"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form 
                className="needs-validation" 
                noValidate
                aria-label="Edit Customer Details">
              <div className="modal-body">
                <div className="modal-content-body container">
                  <div className="details-header">
                    <i className="bi bi-buildings-fill text-size5 blk-clr" aria-hidden="true"></i>
                    <div className="text-size6 ft-wt blk-clr spacer-margin7">
                      {name?.name}
                    </div>
                  </div>
                  <hr />
                  {/* <div className="field-wrapper">
                    <label htmlFor="CustomerID">Customer Name</label>
                    <input className="form-control" />
                    <div className="alert alert-danger" hidden>
                      Customer name is required.
                    </div>
                  </div> */}
                  {/*Address 1*/}
                  <div className="field-wrapper">
                    <label htmlFor="Street1">Address 1</label>
                    <span className="sr-only">(required)</span>
                    <input
                      className="form-control"
                      name="Street1"
                      id="Street1"
                      value={answers?.Street1 ?? ""}
                      autoComplete="address-line1"
                      aria-required="true"
                      aria-invalid={(!answers?.Street1 && frmSubmFlag) ? "true" : "false"}
                      aria-describedby={(!answers?.Street1 && frmSubmFlag) ? "street1Error" : undefined}
                      onChange={(el) => setAnswer("Street1", el.target.value)}
                    />
                    {!answers?.Street1 && frmSubmFlag ? (
                      <div id="street1Error" className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                        Address is required.
                      </div>
                    ) : null}
                  </div>
                  {/*Address 2*/}
                  <div className="field-wrapper">
                    <label htmlFor="Street2">Address 2</label>
                    <input
                      className="form-control"
                      name="Street2"
                      placeholder="Optional"
                      value={answers?.Street2 ?? ""}
                      autoComplete="address-line2"
                      onChange={(el) => setAnswer("Street2", el.target.value)}
                    />
                  </div>
                  <div className="field-wrapper">
                    <label htmlFor="city">City</label>
                    <span className="sr-only">(required)</span>
                    <input
                      className="form-control"
                      name="City"
                      id="City"
                      value={answers?.City ?? ""}
                      autoComplete="address-level2"
                      aria-required="true"
                      aria-invalid={(!answers?.City && frmSubmFlag) ? "true" : "false"}
                      aria-describedby={(!answers?.City && frmSubmFlag) ? "cityError" : undefined}
                      onChange={(el) => setAnswer("City", el.target.value)}
                    />
                    {!answers?.City && frmSubmFlag ? (
                      <div className="field-wrapper">
                        <div id="cityError" className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                          City is required.
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="field-wrapper">
                    {/*State*/}
                    <div className="field-box1 field-ext">
                      <label htmlFor="edit-customer-state">State</label>
                      <span className="sr-only">(required)</span>
                      <select
                        className="form-control"
                        name="State"
                        id="edit-customer-state"
                        value={answers?.State ?? ""}
                        aria-required="true"
                        aria-invalid={(!answers?.State && frmSubmFlag) ? "true" : "false"}
                        aria-describedby={(!answers?.State && frmSubmFlag) ? "stateError" : undefined}
                        onChange={(el) => setAnswer("State", el.target.value)}
                      >
                        <option value="">Select</option>
                        {stateCodeArray.map((el) => (
                          <option key={el} value={el}>
                            {el}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/*Zip Code*/}
                    <div className="field-box1 field-ext">
                      <label htmlFor="ZIP">Zip</label>
                      <span className="sr-only">(required)</span>
                      <input
                        className="form-control"
                        id="ZIP"
                        name="ZIP"
                        maxLength={5}
                        value={answers?.ZIP || ""}
                        autoComplete="postal-code"
                        aria-required="true"
                        aria-invalid={(!answers?.ZIP && frmSubmFlag) ? "true" : "false"}
                        aria-describedby={(!answers?.ZIP && frmSubmFlag) ? "zipError" : undefined}
                        onChange={(el) => {
                          const onlyNums = el.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                          setAnswer("ZIP", onlyNums);
                        }}
                      />
                    </div>
                    {!answers?.State && frmSubmFlag ? (
                      <div className="field-wrapper">
                        <div id="stateError" className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                          State is required.
                        </div>
                      </div>
                    ) : null}

                    {frmSubmFlag && (
                      <>
                        {!answers?.ZIP ||
                        getDigits(answers?.ZIP).length === 0 ? (
                          <div className="field-wrapper">
                            <div id="zipError" className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                              Zip Code is required.
                            </div>
                          </div>
                        ) : isPartialZIP(answers?.ZIP) ? (
                          <div className="field-wrapper">
                            <div id="zipError" className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                              Invalid Zip Code
                            </div>
                          </div>
                        ) : null}
                      </>
                    )}
                  </div>
                  {/*Phone*/}
                  <div className="field-wrapper ">
                    <div className="field-box1 text-robo-reg">
                      <label htmlFor="Phone">Phone</label>
                      <span className="sr-only">(required)</span>
                      <input
                        className="form-control"
                        id="Phone"
                        name="Phone"
                        value={formatPhoneNumber(answers?.Phone) ?? ""}
                        onChange={(el) => setAnswer("Phone", el.target.value)}
                        autoComplete="tel"
                        aria-required="true"
                        aria-invalid={(!answers?.Phone && frmSubmFlag) ? "true" : "false"}
                        aria-describedby={(!answers?.Phone && frmSubmFlag) ? "phoneError" : undefined}
                      />
                      {!answers?.Phone && frmSubmFlag ? (
                        <div id="phoneError" className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                          Phone number is required.
                        </div>
                      ) : null}

                      {answers?.Phone &&
                      answers?.Phone?.length < 14 &&
                      frmSubmFlag ? (
                        <div id="phoneError" className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                          Invalid Phone Number
                        </div>
                      ) : null}
                    </div>
                    <div className="spacer-inline field-ext v-top">
                      <label htmlFor="PhoneExt" aria-label="Phone Extension">Ext</label>
                      <input
                        className="form-control"
                        id="PhoneExt"
                        name="PhoneExt"
                        autoComplete="tel-extension"
                        maxLength={6}
                        value={answers?.PhoneExt ?? ""}
                        onChange={(el) => {
                          const onlyNums = el.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                          setAnswer("PhoneExt", onlyNums, true);
                        }}
                      />
                    </div>
                  </div>
                  {/*Fax*/}
                  <div className="field-wrapper">
                    <div className="field-box1 text-robo-reg">
                      <label htmlFor="Fax">Fax</label>
                      <input
                        className="form-control"
                        type="tel"
                        name="Fax"
                        id="Fax"
                        value={formatPhoneNumber(answers?.Fax) ?? ""}
                        placeholder="Optional"
                        onChange={(el) => setAnswer("Fax", el.target.value)}
                        autoComplete="off"
                        aria-required="false"
                        aria-invalid={answers?.Fax?.length > 0 && answers?.Fax?.length < 14 ? "true" : "false"}
                        aria-describedby={answers?.Fax?.length > 0 && answers?.Fax?.length < 14 ? "faxError" : undefined}
                      />
                      {answers?.Fax?.length < 14 &&
                      answers?.Fax.length > 0 &&
                      frmSubmFlag ? (
                        <div id="faxError" className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                          Invalid Fax Number
                        </div>
                      ) : null}
                    </div>
                    <div className="spacer-inline field-ext v-top">
                      <label htmlFor="FaxExt" aria-label="Fax Extension">Ext</label>
                      <input
                        className="form-control"
                        id="FaxExt"
                        name="FaxExt"
                        autoComplete="off"
                        maxLength={6}
                        value={answers?.FaxExt ?? ""}
                        disabled={
                          answers?.Fax?.replace(/[^0-9]/g, "").length === 0
                        }
                        aria-disabled={
                            answers?.Fax?.replace(/[^0-9]/g, "").length === 0 ? "true" : undefined
                        }
                        onChange={(el) => {
                          const onlyNums = el.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                          setAnswer("FaxExt", onlyNums, true);
                        }}
                      />
                    </div>
                  </div>
                </div>
                {/*Processing Spinner*/}
                {/*{processing ? <div className="loading-edit"></div> : null}*/}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={updateUser}
                  aria-busy={processing}
                  disabled={processing}
                >
                  {processing ? "Updating..." : "Update"}
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={(e) => {
                    CloseModal();
                    ClearFields();
                    SetFrmSubmFlag(false);
                  }}
                  disabled={processing}
                >
                  Cancel
                </button>
              </div>
              {processing && (
                <div 
                    className="loader-container" 
                    role="status" 
                    aria-live="polite" 
                    aria-atomic="true"
                    aria-labelledby="edit-customer-loader"
                >
                  <div className="spinner" aria-hidden="true"></div>
                  <div className="loading-text" id="edit-customer-loader">{loadingText}</div>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCustomer;
